/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import {
    object, node,
} from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';

import mbpUtil from 'mbp-api-util';
import BrandTheme from './BrandTheme/BrandTheme';
import { getBrand } from '../../../../state/ducks/App/ducks/Config/Config-Selectors';
import GraphqlPassportContainer from './GraphqlPassportContainer';

const REACT_APP_INJECTABLE = mbpUtil.getEnv('REACT_APP_INJECTABLE');

const AppShell = ({
    children, brand,
}) => (
    <BrandTheme
        brand={brand}
    >
        {REACT_APP_INJECTABLE === 'false'  && <GraphqlPassportContainer />}
        {children}
    </BrandTheme>
);

const mapStateToProps = (state) => ({
    brand: getBrand(state),
});

AppShell.propTypes = {
    children: node.isRequired,
    brand: object,
};

AppShell.defaultProps = {
    brand: null,
};

export default compose(
    connect(mapStateToProps),
)(AppShell);
